import firebase from "../../firebase";

export default function(officeId) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "user",
        funcName: "syncUserAttributes",
        data: { officeId }
    });
}
